import { render, staticRenderFns } from "./BandeiraAmex.vue?vue&type=template&id=c3cc218c&"
import script from "./BandeiraAmex.vue?vue&type=script&lang=js&"
export * from "./BandeiraAmex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports